// extracted by mini-css-extract-plugin
module.exports = {"modalRoot":"ModalRoot_modalRoot__33Glw"};